"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TermsAndConditionsConsent = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _types = require("../../types");
var _FormattedMessage = require("../FormattedMessage");
var _TermsAndConditionsDialog = require("./TermsAndConditionsDialog");
var _TermsLink = require("./TermsLink");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        marginTop: theme.spacing(4),
        textAlign: 'center',
        fontSize: theme.typography.pxToRem(12),
        lineHeight: 1.75
    };
});
const TermsAndConditionsConsent = (props)=>{
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { privacyPolicyTermId, termsAndConditionsDialogProps, termsAndConditionsTermId, togglePrivacyPolicyDialog, toggleTermsAndConditionsDialog } = (0, _hooks.useTermsAndConditionsConsent)(props);
    const termsAndConditions = (children)=>termsAndConditionsTermId ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TermsLink.TermsLink, {
            onClick: toggleTermsAndConditionsDialog,
            children: children
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TermsLink.TermsLink, {
            children: children
        });
    const privacyPolicy = (children)=>privacyPolicyTermId ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TermsLink.TermsLink, {
            onClick: togglePrivacyPolicyDialog,
            children: children
        }) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
                ...getTestIdProps(_types.TestId.TermsAndConditionsConsent),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                    id: "byClickingFinaliseOrder",
                    values: {
                        termsAndConditions,
                        privacyPolicy
                    }
                })
            }),
            Boolean(termsAndConditionsTermId) || Boolean(privacyPolicyTermId) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TermsAndConditionsDialog.TermsAndConditionsDialog, {
                ...termsAndConditionsDialogProps
            }) : null
        ]
    });
};
exports.TermsAndConditionsConsent = TermsAndConditionsConsent;
